import ClientNotificationInterface from '../../interfaces/client/Notification'

export default (
  notifications: ClientNotificationInterface[],
  notificationToFilter: ClientNotificationInterface[]
) => {
  const newNotificationsMessages = notificationToFilter.map(
    (notification: ClientNotificationInterface) => notification.message
  )

  return notifications.filter((notification: ClientNotificationInterface) =>
    notification.isGlobal
      ? !newNotificationsMessages.includes(notification.message)
      : notification
  )
}
